const errorText = "加载失败，请稍后再试"
const deleteError = "删除失败，请稍后再试"
const saveError = "保存失败，请稍后再试"

// let DOMAIN = 'http://tlyu.51yxxg.com/api' // 测试
let DOMAIN = 'http://tlbm.wanglanyun.cn/api' //开发环境
// let DOMAIN = 'http://192.168.2.104:8888' //开发

const URL = {
    /**
     * 系统登录注册修改信息等url
     * */
    login: DOMAIN + '/user/login',
    logout: DOMAIN + '/user/logout' ,
    user_info: DOMAIN + '/user/profile',
    change_password: DOMAIN + '/user/password',
    upload_url: DOMAIN + '/common/upload/config',

    /**
     * 账号管理相关url
     * */
    account_url: DOMAIN + '/user',

    /**
     * 角色管理相关url
     * */
    role_url: DOMAIN + '/role',

    /**
     * 系统日志相关url
     * */
    systemLog_url: DOMAIN + '/action',

    /**
     * 数据管理相关url
     * */
    data_url: DOMAIN + '/student',

    /**
     * 表单管理相关url
     * */
    form_url: DOMAIN + '/form/item',

};

export default {
    URL,
    DOMAIN,
    errorText,
    deleteError,
    saveError
}
